// adblock detection ported from https://github.schibsted.io/spt-advertising/adblock-detect/blob/master/snippet.html
import { config } from '../config';

const { adblockDetect: opts } = config;

// loading/checking state
const checking = {
    loading: true,
    hasAdBlock: undefined,
};

const cbs = [];

// Using old-school node callback style, to let adblock detection to be ran before any callbacks are added
const addCallback = (cb) => {
    if (checking.loading) {
        cbs.push(cb);
        return;
    }
    if (checking.hasAdBlock) {
        cb(checking.hasAdBlock);
        return;
    }
    cb();
};

const oncheckComplete = (error) => {
    checking.loading = false;
    // if the error is not undefined, adblock has been detected (reason in error type)
    checking.hasAdBlock = error;
    // empty queue and call callbacks
    while (cbs.length) {
        cbs.shift()(error);
    }
};

function onScriptLoad(frameEl, globalToCheck) {
    const globalAccessible = frameEl.contentWindow[globalToCheck];
    if (globalAccessible) {
        oncheckComplete();
    } else {
        oncheckComplete(new Error(`${globalToCheck} was not defined`));
    }
    frameEl.parentNode.removeChild(frameEl);
}

function onScriptError(src) {
    // assume that if the script fails to load, it's being blocked
    oncheckComplete(new Error(`The script ${src} did not load`));
}

function createFrame() {
    const frameEl = document.createElement('iframe');
    if (frameEl.hidden === undefined) {
        frameEl.style.display = 'none';
    }
    frameEl.hidden = true;
    return frameEl;
}

function insertScript(src, frameEl, globalToCheck) {
    const document = frameEl.contentDocument;
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => onScriptLoad(frameEl, globalToCheck);
    script.onerror = () => onScriptError(src);
    document.body.appendChild(script);
}

const onload = () => {
    const { path, globalVarToCheck, urls } = opts;

    window.removeEventListener('load', onload);

    const onIdle = () => {
        const iframe = createFrame();
        const iframeLoaded = () => {
            iframe.removeEventListener('load', iframeLoaded);
            insertScript(
                `${urls[Math.floor(Math.random() * urls.length)]}/${path}`,
                iframe,
                globalVarToCheck,
            );
        };
        iframe.addEventListener('load', iframeLoaded, false);
        document.body.appendChild(iframe);
    };

    // wait for the UI thread to be idle
    setTimeout(onIdle, 10);
};

// do not run in node context
if (typeof window !== 'undefined') {
    window.addEventListener('load', onload);
}

export default addCallback;



/** WEBPACK FOOTER **
 ** ./src/utils/adblock-detect.js
 **/